import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import { db } from "../../../../firebase";
import dayjs from "dayjs";

const RentalInformation = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [isUseCustomInspectionDate, setisUseCustomInspectionDate] =
    useState(false);

  const { TextArea } = Input;

  const customInspectionChange = (e) => {
    console.log(e.target.checked);
    setisUseCustomInspectionDate(e.target.checked);
  };
  const dateFormat = "YYYY/MM/DD";
  console.log("***********");
  const initialValues = {
    bedrooms: data?.bedrooms || "",
    bathrooms: data?.bathrooms || "",
    squareFeet: data?.squareFeet || "",
    marketRent: data?.marketRent || "",
    marketRentOnAds: data?.marketRentOnAds || false,
    adminFee: data?.adminFee || "",
    applicationFee: data?.applicationFee || "",
    securityDeposit: data?.securityDeposit || "",
    NSFFee: data?.NSFFee || "",
    UseCustomInspectionDate: isUseCustomInspectionDate,
    lastInspectionOn: data?.lastInspectionOn
      ? dayjs(data?.lastInspectionOn, dateFormat)
      : null,
    rentStatus: data?.rentStatus || "",
    legalRent: data?.legalRent || "",
    preferentialRent: data?.preferentialRent || "",
    utilitiesIncludedInLease: data?.utilitiesIncludedInLease || [],
    appliancesIncludedInLease: data?.appliancesIncludedInLease || [],
    additionalLeaseInformation: data?.additionalLeaseInformation || "",
  };

  const onFinish = (fieldsValue) => {
    const values = {
      ...fieldsValue,
      lastInspectionOn: fieldsValue["lastInspectionOn"]
        ? fieldsValue["lastInspectionOn"].format("YYYY-MM-DD")
        : null,
    };
    console.log("Success:", values);
    console.log("iididi:", dataId);
    isUpdate(true);
    setIsWaiting(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef,companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "rentalInformation.bedrooms": values.bedrooms || "",
        "rentalInformation.bathrooms": values.bathrooms || "",
        "rentalInformation.squareFeet": values.squareFeet || "",
        "rentalInformation.marketRent": values.marketRent || "",
        "rentalInformation.marketRentOnAds": values.marketRentOnAds || "",
        "rentalInformation.adminFee": values.adminFee || "",
        "rentalInformation.applicationFee": values.applicationFee || "",
        "rentalInformation.securityDeposit": values.securityDeposit || "",
        "rentalInformation.NSFFee": values.NSFFee || "",
        "rentalInformation.lastInspectionOn": values.lastInspectionOn || "",
        "rentalInformation.rentStatus": values.rentStatus || "",
        "rentalInformation.legalRent": values.legalRent || "",
        "rentalInformation.preferentialRent": values.preferentialRent || "",
        "rentalInformation.utilitiesIncludedInLease":
          values.utilitiesIncludedInLease || "",
        "rentalInformation.appliancesIncludedInLease":
          values.appliancesIncludedInLease || "",
        "rentalInformation.additionalLeaseInformation":
          values.additionalLeaseInformation || "",
      });
      message.success("Rental Information Data Updated Successfully..", 3);

      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      message.error("Failed to update Rental Information data", 3);

      setIsWaiting(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  return (
    <div>
      <Card
        title="Rental Information"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
            offset: 6,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Bedrooms" name="bedrooms">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "0",
                  },
                  {
                    value: "1",
                  },
                  {
                    value: "2",
                  },
                  {
                    value: "3",
                  },
                  {
                    value: "4",
                  },
                  {
                    value: "5",
                  },
                ]}
              />
            ) : (
              <p>{data?.bedrooms === "" ? "--" : data?.bedrooms}</p>
            )}
          </Form.Item>
          <Form.Item label="Bathrooms" name="bathrooms">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "0",
                  },
                  {
                    value: "0.5",
                  },
                  {
                    value: "1",
                  },
                  {
                    value: "1.5",
                  },
                  {
                    value: "2",
                  },
                  {
                    value: "2.5",
                  },
                ]}
              />
            ) : (
              <p>{data?.bathrooms === "" ? "--" : data?.bathrooms}</p>
            )}
          </Form.Item>
          <Form.Item label="Square Feet" name="squareFeet">
            {isEditActive ? (
              <Input />
            ) : (
              <p>{data?.squareFeet === "" ? "--" : data?.squareFeet}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Market Rent"
            name="marketRent"
            extra={<a href="#"> Change Market Rent</a>}
          >
            {isEditActive ? (
              <Input
                placeholder="Amount"
                addonBefore={<FaDollarSign size={12} />}
                disabled
              />
            ) : (
              <p>
                {data?.marketRent === "" ? "--" : data?.marketRent}
                <a href="#"> RentMatch Comparison</a>
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="Use Market Rent on Ads?"
            name="marketRentOnAds"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.marketRentOnAds ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          <Form.Item label="Admin Fee" name="adminFee">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>{data?.adminFee === "" ? "--" : data?.adminFee}</p>
            )}
          </Form.Item>
          <Form.Item label="Application Fee " name="applicationFee">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>{data?.applicationFee === "" ? "--" : data?.applicationFee}</p>
            )}
          </Form.Item>
          <Form.Item label="Security Deposit" name="securityDeposit">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>
                {data?.securityDeposit === "" ? "--" : data?.securityDeposit}
              </p>
            )}
          </Form.Item>
          <Form.Item label="NSF Fee" name="NSFFee">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>{data?.NSFFee === "" ? "--" : data?.NSFFee}</p>
            )}
          </Form.Item>
          {isEditActive ? (
            <Form.Item
              label="Use Custom Inspection Date"
              name="UseCustomInspectionDate"
              onChange={customInspectionChange}
              valuePropName="checked"
            >
              <Checkbox></Checkbox>
            </Form.Item>
          ) : null}
          <Form.Item label="Last Inspection On" name="lastInspectionOn">
            {isUseCustomInspectionDate && isEditActive ? (
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            ) : (
              <a href="#">
                {data?.lastInspectionOn === "" ? "--" : data?.lastInspectionOn}
              </a>
            )}
          </Form.Item>
          <Form.Item label="Rent Status" name="rentStatus">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Rent Controlled",
                  },
                  {
                    value: "Rent Stabilized",
                  },
                  {
                    value: "Decontrolled",
                  },
                ]}
              />
            ) : (
              <p>{data?.rentStatus === "" ? "--" : data?.rentStatus}</p>
            )}
          </Form.Item>
          <Form.Item label="Legal Rent" name="legalRent">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>{data?.legalRent === "" ? "--" : data?.legalRent}</p>
            )}
          </Form.Item>
          <Form.Item label="Preferential Rent" name="preferentialRent">
            {isEditActive ? (
              <Input addonBefore={<FaDollarSign size={12} />} />
            ) : (
              <p>
                {data?.preferentialRent === "" ? "--" : data?.preferentialRent}
              </p>
            )}
          </Form.Item>
          <Form.Item
            label="Utilities Included"
            name="utilitiesIncludedInLease"
            extra={isEditActive && <a href="#"> Manage Tags</a>}
          >
            {isEditActive ? (
              <Select
                mode="tags"
                allowClear
                style={{
                  width: "100%",
                }}
                options={[
                  { value: "test1" },
                  { value: "test2" },
                  { value: "test3" },
                  { value: "test4" },
                  { value: "test5" },
                ]}
              />
            ) : (
              <>
                {data?.utilitiesIncludedInLease?.length > 0
                  ? data?.utilitiesIncludedInLease?.map((utilities) => (
                      <p key={utilities}>{utilities}</p>
                    ))
                  : "--"}
              </>
            )}
          </Form.Item>
          <Form.Item
            label="Appliances Included"
            name="appliancesIncludedInLease"
            extra={isEditActive && <a href="#"> Manage Tags</a>}
          >
            {isEditActive ? (
              <Select
                mode="tags"
                allowClear
                style={{
                  width: "100%",
                }}
                options={[
                  { value: "test1" },
                  { value: "test2" },
                  { value: "test3" },
                  { value: "test4" },
                  { value: "test5" },
                ]}
              />
            ) : (
              <>
                {data?.appliancesIncludedInLease?.length > 0
                  ? data?.appliancesIncludedInLease?.map((applications) => (
                      <p key={applications}>{applications}</p>
                    ))
                  : "--"}
              </>
            )}
          </Form.Item>
          <Form.Item
            label="Additional Lease Information"
            name="additionalLeaseInformation"
          >
            {isEditActive ? (
              <TextArea
                style={{
                  height: 120,
                  resize: "none",
                }}
              />
            ) : (
              <p>
                {data?.additionalLeaseInformation === ""
                  ? "--"
                  : data?.additionalLeaseInformation}
              </p>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default RentalInformation;
